export default {"src":"/_next/static/media/ecm-to-lz.d6acb5a6.svg","height":72,"width":840};